<template>
    <div class="placeholder">
        <div class="placeholder__heading">
            {{ data.name }}
        </div>
        <div class="placeholder">
            
            <vue-good-table
                :columns="columns"
                :rows="data.sub_projects"
                :search-options="searchOptions"
                :pagination-options="paginationOptions"
                :sort-options="sortOptions"
                :styleClass="styleClass"
            >
                <div slot="emptystate">
                    Ingen data ...
                </div>
                <template slot="table-row" slot-scope="props">
                    <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                        {{ props.row.coverage_percent | coveragePercent }} 
                        <div
                            v-if="props.row.coverage_percent !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                        />
                    </div>
                    <div v-else-if="props.column.field == 'total_revenue'">
                        {{ props.row.total_revenue | currency}}
                    </div>
                    <div v-else-if="props.column.field == 'total_coverage'">
                        <project-tooltip :project="props.row" />
                        {{ props.row.total_coverage | currency}}
                    </div>
                    <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                        {{ props.row.coverage_per_hour | currency }} 
                        <div
                            v-if="props.row.coverage_per_hour !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                        />
                    </div>
                    <div v-else-if="props.column.field == 'customer_name'" class="table-column__customer" :title="props.row.customer_name">
                        <span v-if="props.row.customer_name">
                            {{ props.row.customer_name }}
                        </span>
                        <span v-else> - </span>
                    </div>
                    <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name">
                        <!--<d-tooltip placement="left" :space="true" :content="props.row.description" />-->
                        {{ props.row.name }}
                    </div>
                    <div v-else-if="props.column.field == 'start_date'">
                        {{ props.row.start_date | moment("DD. MMM YYYY") }}
                    </div>
                    <div v-else-if="props.column.field == 'minuba_external_id'">
                        <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                            <i class="fas fa-eye"></i>
                        </a>
                    </div>
                    <div v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                </template>
            </vue-good-table>
            
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data () {
        return {
            columns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Opgave', field: 'name' },
                { label: 'Kunde', field: 'customer_name', type: 'string' },
                { label: 'Startdato', field: 'start_date', type: 'string' },
                { label: 'Omsætning', field: 'total_revenue', type: 'number' },
                { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    mounted () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
    }
}
</script>



// WEBPACK FOOTER //
// responsibleProjects.vue?d74e307c